export type TMGColor = {
  hex: string;
  rgb?: string;
  rgba?: string;
  shade?: number;
};

// ********************************************************
// Generic Colors
// ********************************************************

const MG01700Color: TMGColor = {
  shade: 900,
  hex: "#212529",
  rgba: "rgba(33, 37, 41, 100%)",
  rgb: "33, 37, 41",
};

const MG01600Color: TMGColor = {
  shade: 800,
  hex: "#373737",
  rgba: "rgba(55, 55, 55, 100%)",
  rgb: "55, 55, 55",
};

const MG01500Color: TMGColor = {
  shade: 700,
  hex: "#57595A",
  rgba: "rgba(87, 89, 90, 100%)",
  rgb: "87, 89, 90",
};

const MG01400Color: TMGColor = {
  shade: 600,
  hex: "#6D6F71",
  rgba: "rgba(109, 111, 113, 100%)",
  rgb: "109, 111, 113",
};

const MG01300Color: TMGColor = {
  shade: 500,
  hex: "#8A8C8D",
  rgba: "rgba(138, 140, 141, 100%)",
  rgb: "138, 140, 141",
};

const MG01200Color: TMGColor = {
  shade: 400,
  hex: "#A7A9AA",
  rgba: "rgba(167, 169, 170, 100%)",
  rgb: "167, 169, 170",
};

const MG01100Color: TMGColor = {
  shade: 300,
  hex: "#B2B2B2",
  rgba: "rgba(178, 178, 178, 100%)",
  rgb: "178, 178, 178",
};

const MG0190Color: TMGColor = {
  shade: 200,
  hex: "#DDDDDD",
  rgba: "rgba(221, 221, 221, 100%)",
  rgb: "221, 221, 221",
};

const MG0180Color: TMGColor = {
  shade: 100,
  hex: "#F5F5F5",
  rgba: "rgba(245, 245, 245, 100%)",
  rgb: "245, 245, 245",
};

const MG0170Color: TMGColor = {
  shade: 0,
  hex: "#FFFFFF",
  rgba: "rgba(255, 255, 255, 100%)",
  rgb: "255, 255, 255",
};

const MG02500Color: TMGColor = {
  shade: 700,
  hex: "#993500",
  rgba: "rgba(153, 53, 0, 100%)",
  rgb: "153, 53, 0",
};

const MG02400Color: TMGColor = {
  shade: 600,
  hex: "#CE4100",
  rgba: "rgba(206, 65, 0, 100%)",
  rgb: "206, 65, 0",
};

const MG02300Color: TMGColor = {
  shade: 500,
  hex: "#D04301",
  rgba: "rgba(208, 67, 1, 100%)",
  rgb: "208, 67, 1",
};

const MG02200Color: TMGColor = {
  shade: 400,
  hex: "#F05A22",
  rgba: "rgba(240, 90, 34, 100%)",
  rgb: "240, 90, 34",
};

const MG02100Color: TMGColor = {
  shade: 300,
  hex: "#FF5800",
  rgba: "rgba(255, 88, 0, 100%)",
  rgb: "255, 88, 0",
};

const MG0290Color: TMGColor = {
  shade: 200,
  hex: "#FFBC99",
  rgba: "rgba(255, 188, 153, 100%)",
  rgb: "255, 188, 153",
};

const MG0280Color: TMGColor = {
  shade: 100,
  hex: "#FFDECC",
  rgba: "rgba(255, 222, 204, 100%)",
  rgb: "255, 222, 204",
};

const MG0270Color: TMGColor = {
  shade: 50,
  hex: "#FFEEE6",
  rgba: "rgba(255, 238, 230, 100%)",
  rgb: "255, 238, 230",
};

const MG03700Color: TMGColor = {
  shade: 900,
  hex: "#06151D",
  rgba: "rgba(6, 21, 29, 100%)",
  rgb: "6, 21, 29",
};

const MG03600Color: TMGColor = {
  shade: 800,
  hex: "#0C2A3B",
  rgba: "rgba(12, 42, 59, 100%)",
  rgb: "12, 42, 59",
};

const MG03500Color: TMGColor = {
  shade: 700,
  hex: "#134058",
  rgba: "rgba(19, 64, 88, 100%)",
  rgb: "19, 64, 88",
};

const MG03400Color: TMGColor = {
  shade: 600,
  hex: "#195576",
  rgba: "rgba(25, 85, 118, 100%)",
  rgb: "25, 85, 118",
};

const MG03300Color: TMGColor = {
  shade: 500,
  hex: "#1F6A93",
  rgba: "rgba(31, 106, 147, 100%)",
  rgb: "31, 106, 147",
};

const MG03200Color: TMGColor = {
  shade: 400,
  hex: "#4685A7",
  rgba: "rgba(70, 133, 167, 100%)",
  rgb: "70, 133, 167",
};

const MG03100Color: TMGColor = {
  shade: 300,
  hex: "#6DA0BC",
  rgba: "rgba(109, 160, 188, 100%)",
  rgb: "109, 160, 188",
};

const MG0390Color: TMGColor = {
  shade: 200,
  hex: "#93BAD0",
  rgba: "rgba(147, 186, 208, 100%)",
  rgb: "147, 186, 208",
};

const MG0380Color: TMGColor = {
  shade: 100,
  hex: "#BAD5E5",
  rgba: "rgba(186, 213, 229, 100%)",
  rgb: "186, 213, 229",
};

const MG0370Color: TMGColor = {
  shade: 50,
  hex: "#E1F0F9",
  rgba: "rgba(225, 240, 249, 100%)",
  rgb: "225, 240, 249",
};

const MG04600Color: TMGColor = {
  shade: 200,
  hex: "#A76801",
  rgba: "rgba(167, 104, 1, 100%)",
  rgb: "167, 104, 1",
};

const MG04300Color: TMGColor = {
  shade: 100,
  hex: "#EB2D5B",
  rgba: "rgba(235, 45, 91, 100%)",
  rgb: "235, 45, 91",
};

const MG0480Color: TMGColor = {
  shade: 70,
  hex: "#FBB14C",
  rgba: "rgba(251, 177, 76, 100%)",
  rgb: "251, 177, 76",
};

const MG0420Color: TMGColor = {
  shade: 40,
  hex: "#FFDDB1",
  rgba: "rgba(255, 221, 177, 100%)",
  rgb: "255, 221, 177",
};

const MG05600Color: TMGColor = {
  shade: 200,
  hex: "#466591",
  rgba: "rgba(70, 101, 145, 100%)",
  rgb: "70, 101, 145",
};

const MG05300Color: TMGColor = {
  shade: 100,
  hex: "#6E95CB",
  rgba: "rgba(110, 149, 203, 100%)",
  rgb: "110, 149, 203",
};

const MG0580Color: TMGColor = {
  shade: 70,
  hex: "#99A1B0",
  rgba: "rgba(153, 161, 176, 100%)",
  rgb: "153, 161, 176",
};

const MG0520Color: TMGColor = {
  shade: 40,
  hex: "#BCC2CF",
  rgba: "rgba(188, 194, 207, 100%)",
  rgb: "188, 194, 207",
};

const MG06300Color: TMGColor = {
  shade: 100,
  hex: "#627693",
  rgba: "rgba(98, 118, 147, 100%)",
  rgb: "98, 118, 147",
};

const MG0680Color: TMGColor = {
  shade: 70,
  hex: "#FBB14C",
  rgba: "rgba(251, 177, 76, 100%)",
  rgb: "251, 177, 76",
};

const MG0620Color: TMGColor = {
  shade: 40,
  hex: "#FFDDB1",
  rgba: "rgba(255, 221, 177, 100%)",
  rgb: "255, 221, 177",
};

const MG07400Color: TMGColor = {
  shade: 200,
  hex: "#C91B45",
  rgba: "rgba(201, 27, 69, 100%)",
  rgb: "201, 27, 69",
};

const MG07300Color: TMGColor = {
  shade: 100,
  hex: "#EB2D5B",
  rgba: "rgba(235, 45, 91, 100%)",
  rgb: "235, 45, 91",
};

const MG0780Color: TMGColor = {
  shade: 70,
  hex: "#FF95AF",
  rgba: "rgba(255, 149, 175, 100%)",
  rgb: "255, 149, 175",
};

const MG0720Color: TMGColor = {
  shade: 40,
  hex: "#FCE1E1",
  rgba: "rgba(252, 225, 225, 100%)",
  rgb: "252, 225, 225",
};

const MG08400Color: TMGColor = {
  shade: 200,
  hex: "#55772A",
  rgba: "rgba(85, 119, 42, 100%)",
  rgb: "85, 119, 42",
};

const MG08300Color: TMGColor = {
  shade: 100,
  hex: "#9DCE5E",
  rgba: "rgba(157, 206, 94, 100%)",
  rgb: "157, 206, 94",
};

const MG0880Color: TMGColor = {
  shade: 70,
  hex: "#B7EB73",
  rgba: "rgba(183, 235, 115, 100%)",
  rgb: "183, 235, 115",
};

const MG0820Color: TMGColor = {
  shade: 40,
  hex: "#E6F0D9",
  rgba: "rgba(230, 240, 217, 100%)",
  rgb: "230, 240, 217",
};

const MG09100Color: TMGColor = {
  shade: 300,
  hex: "#FFD139",
  rgba: "rgba(255, 209, 57, 100%)",
  rgb: "255, 209, 57",
};

const MG10300Color: TMGColor = {
  shade: 100,
  hex: "#A4BBE5",
  rgba: "rgba(164, 187, 229, 100%)",
  rgb: "164, 187, 229",
};

const MG11100Color: TMGColor = {
  shade: 100,
  hex: "#EFF0F2",
  rgba: "rgba(239, 240, 242, 100%)",
  rgb: "239, 240, 242",
};

// ********************************************************
// Neutral Colors
// ********************************************************

const MGWhiteColor: TMGColor = {
  ...MG0170Color,
};

const MGNeutral100Color: TMGColor = {
  ...MG0180Color,
};

const MGNeutral200Color: TMGColor = {
  ...MG0190Color,
};

const MGNeutral300Color: TMGColor = {
  ...MG01100Color,
};

const MGNeutral400Color: TMGColor = {
  ...MG01200Color,
};

const MGNeutral500Color: TMGColor = {
  ...MG01300Color,
};

const MGNeutral600Color: TMGColor = {
  ...MG01400Color,
};

const MGNeutral700Color: TMGColor = {
  ...MG01500Color,
};

const MGNeutral800Color: TMGColor = {
  ...MG01600Color,
};

const MGBlackColor: TMGColor = {
  ...MG01700Color,
};

// ********************************************************
// Brand Colors
// ********************************************************

const MGBrand01100Color: TMGColor = {
  ...MG02100Color,
};

const MGBrand01200Color: TMGColor = {
  shade: 100,
  hex: "#FFA000",
  rgba: "rgba(255, 160, 0, 100%)",
  rgb: "255, 160, 0",
};

const MGBrand02100Color: TMGColor = {
  ...MG01600Color,
};

const MGBrand02200Color: TMGColor = {
  ...MG03300Color,
};

// ********************************************************
// Semantic Colors
// ********************************************************

const MGError20Color: TMGColor = {
  ...MG0720Color,
};

const MGError40Color: TMGColor = {
  ...MG0780Color,
};

const MGError80Color: TMGColor = {
  ...MG07300Color,
};

const MGError100Color: TMGColor = {
  ...MG07400Color,
};

const MGSuccess20Color: TMGColor = {
  ...MG0820Color,
};

const MGSuccess40Color: TMGColor = {
  ...MG0880Color,
};

const MGSuccess80Color: TMGColor = {
  ...MG08300Color,
};

const MGSuccess100Color: TMGColor = {
  ...MG08400Color,
};

const MGWarning20Color: TMGColor = {
  ...MG0420Color,
};

const MGWarning40Color: TMGColor = {
  ...MG0480Color,
};

const MGWarning80Color: TMGColor = {
  ...MGBrand01200Color,
};

const MGWarning100Color: TMGColor = {
  ...MG04600Color,
};

const MGInformation20Color: TMGColor = {
  shade: 40,
  hex: "#DAE6FF",
  rgba: "rgba(218, 230, 255, 100%)",
  rgb: "218, 230, 255",
};

const MGInformation40Color: TMGColor = {
  shade: 70,
  hex: "#99B1CE",
  rgba: "rgba(153, 177, 206, 100%)",
  rgb: "153, 177, 206",
};

const MGInformation80Color: TMGColor = {
  ...MG05300Color,
};

const MGInformation100Color: TMGColor = {
  ...MG05600Color,
};

// ********************************************************
// Neutral Colors
// ********************************************************

export const MGColorsNeutral = {
  black: { ...MGBlackColor },
  "neutral-800": { ...MGNeutral800Color },
  "neutral-700": { ...MGNeutral700Color },
  "neutral-600": { ...MGNeutral600Color },
  "neutral-500": { ...MGNeutral500Color },
  "neutral-400": { ...MGNeutral400Color },
  "neutral-300": { ...MGNeutral300Color },
  "neutral-200": { ...MGNeutral200Color },
  "neutral-100": { ...MGNeutral100Color },
  white: { ...MGWhiteColor },
} as const;

// ********************************************************
// Brand Colors
// ********************************************************

export const MGColorsBrand = {
  primary: { ...MGBrand01100Color },
  "primary-variant": { ...MGBrand01200Color },
  "brand-01-100": { ...MGBrand01100Color },
  "brand-01-200": { ...MGBrand01200Color },
  secondary: { ...MGBrand02100Color },
  "secondary-variant": { ...MGBrand02200Color },
  "brand-02-100": { ...MGBrand02100Color },
  "brand-02-200": { ...MGBrand02200Color },
} as const;

// ********************************************************
// Semantic Colors
// ********************************************************

export const MGColorsSemantic = {
  // error
  "feedback-error-20": { ...MGError20Color },
  "feedback-error-40": { ...MGError40Color },
  "feedback-error-80": { ...MGError80Color },
  "feedback-error-100": { ...MGError100Color },
  error: { ...MGError100Color },
  // success
  "feedback-success-20": { ...MGSuccess20Color },
  "feedback-success-40": { ...MGSuccess40Color },
  "feedback-success-80": { ...MGSuccess80Color },
  "feedback-success-100": { ...MGSuccess100Color },
  success: { ...MGSuccess100Color },
  // warning
  "feedback-warning-20": { ...MGWarning20Color },
  "feedback-warning-40": { ...MGWarning40Color },
  "feedback-warning-80": { ...MGWarning80Color },
  "feedback-warning-100": { ...MGWarning100Color },
  warning: { ...MGWarning100Color },
  // information
  "feedback-information-20": { ...MGInformation20Color },
  "feedback-information-40": { ...MGInformation40Color },
  "feedback-information-80": { ...MGInformation80Color },
  "feedback-information-100": { ...MGInformation100Color },
  information: { ...MGInformation100Color },
  // disabled
  "feedback-disabled-10": { ...MGNeutral200Color },
  "feedback-disabled-20": { ...MGNeutral300Color },
  "feedback-disabled-40": { ...MGNeutral500Color },
} as const;

// ********************************************************
// Text Colors
// ********************************************************

export const MGColorsText = {
  // primary
  "text-primary-01": { ...MGBlackColor },
  "text-primary-02": { ...MGNeutral800Color },
  "text-primary-03": { ...MGNeutral600Color },
  "text-primary-04": { ...MGWhiteColor },
  // other
  "text-secondary-01": { ...MG02100Color },
  "text-secondary-02": { ...MG02300Color },
  "text-secondary-03": { ...MG03300Color },
  "text-money-01": { ...MG08400Color },
  // feedback
  "text-feedback-error-100": { ...MG07400Color },
  "text-feedback-error-10": { ...MG0720Color },
  "text-feedback-disabled": { ...MG01300Color },
  // links
  "text-link-enabled-bg-light": { ...MG02300Color },
  "text-link-active-bg-light": { ...MG02400Color },
  "text-link-enabled-bg-dark": { ...MGWhiteColor },
  "text-link-active-bg-dark": { ...MG0180Color },
  "text-link-enabled-bg-brand": { ...MGBlackColor },
  "text-link-active-bg-brand": { ...MGNeutral700Color },
} as const;

// ********************************************************
// Background Colors
// ********************************************************

export const MGColorsBackground = {
  "background-primary-01": { ...MGWhiteColor },
  "background-primary-02": { ...MGNeutral100Color },
  "background-secondary-01": { ...MGNeutral200Color },
  "background-secondary-02": { ...MG11100Color },
} as const;

// ********************************************************
// Card Colors
// ********************************************************

export const MGColorsCard = {
  "background-card-01": { ...MGWhiteColor },
  "background-card-02": { ...MGNeutral200Color },
} as const;

// ********************************************************
// State Colors
// ********************************************************

const MG00000Color: TMGColor = {
  hex: "#000000",
  rgba: "rgba(0, 0, 0, 100%)",
  rgb: "0, 0, 0",
};

export const MGColorsState = {
  "state-focus-100": { ...MG10300Color },
  "state-hover-100": { ...MG00000Color },
  "state-active-100": { ...MG00000Color },
  "state-selected-100": { ...MG00000Color },
  "state-disabled-10": { ...MGNeutral200Color },
  "state-disabled-20": { ...MGNeutral300Color },
  "state-disabled-40": { ...MGNeutral500Color },
} as const;

// ********************************************************
// Interface Colors
// ********************************************************

export const MGColorsInterface = {
  "interface-01": { ...MG09100Color },
} as const;

// ********************************************************
// Generic Colors
// ********************************************************
export const MGColorGeneric = {
  "00-000": { ...MG00000Color },
  // 01
  "01-700": { ...MGBlackColor },
  "01-600": { ...MGNeutral800Color },
  "01-500": { ...MGNeutral700Color },
  "01-400": { ...MGNeutral600Color },
  "01-300": { ...MGNeutral500Color },
  "01-200": { ...MGNeutral400Color },
  "01-100": { ...MGNeutral300Color },
  "01-90": { ...MGNeutral200Color },
  "01-80": { ...MGNeutral100Color },
  "01-70": { ...MGWhiteColor },
  // 02
  "02-500": { ...MG02500Color },
  "02-400": { ...MG02400Color },
  "02-300": { ...MG02300Color },
  "02-200": { ...MG02200Color },
  "02-100": { ...MG02100Color },
  "02-90": { ...MG0290Color },
  "02-80": { ...MG0280Color },
  "02-70": { ...MG0270Color },
  // 03
  "03-700": { ...MG03700Color },
  "03-600": { ...MG03600Color },
  "03-500": { ...MG03500Color },
  "03-400": { ...MG03400Color },
  "03-300": { ...MG03300Color },
  "03-200": { ...MG03200Color },
  "03-100": { ...MG03100Color },
  "03-90": { ...MG0390Color },
  "03-80": { ...MG0380Color },
  "03-70": { ...MG0370Color },
  // 04
  "04-600": { ...MG04600Color },
  "04-300": { ...MG04300Color },
  "04-80": { ...MG0480Color },
  "04-20": { ...MG0420Color },
  // 05
  "05-600": { ...MG05600Color },
  "05-300": { ...MG05300Color },
  "05-80": { ...MG0580Color },
  "05-20": { ...MG0520Color },
  // 06
  "06-300": { ...MG06300Color },
  "06-80": { ...MG0680Color },
  "06-20": { ...MG0620Color },
  // 07
  "07-400": { ...MG07400Color },
  "07-300": { ...MG07300Color },
  "07-80": { ...MG0780Color },
  "07-20": { ...MG0720Color },
  // 08
  "08-400": { ...MG08400Color },
  "08-300": { ...MG08300Color },
  "08-80": { ...MG0880Color },
  "08-20": { ...MG0820Color },
  // 09
  "09-100": { ...MG09100Color },
  // 10
  "10-300": { ...MG10300Color },
} as const;

// ********************************************************
// Color Mappings object
// ********************************************************
export const MGColors = {
  ...MGColorsNeutral,
  ...MGColorsBrand,
  ...MGColorsSemantic,
  ...MGColorsText,
  ...MGColorsBackground,
  ...MGColorsCard,
  ...MGColorsState,
  ...MGColorsInterface,
  ...MGColorGeneric,
} as const;

export type TMGColors = keyof typeof MGColors;

export const MGColorLightBackgrounds = {
  white: "white",
  "light-grey": "light-grey",
  "medium-grey": "medium-grey",
} as const;

export type TMGColorLightBackgrounds = keyof typeof MGColorLightBackgrounds;

export const MGColorPrimaryBackgrounds = {
  light: "light",
  dark: "dark",
  brand: "brand",
} as const;

export type TMGColorPrimaryBackgrounds = keyof typeof MGColorPrimaryBackgrounds;

export const MGColorSemanticBackgrounds = {
  error: "error",
  success: "success",
  warning: "warning",
} as const;

export type TMGColorSemanticBackgrounds = keyof typeof MGColorSemanticBackgrounds;

export const MGColorsBackgrounds = {
  ...MGColorPrimaryBackgrounds,
  ...MGColorLightBackgrounds,
  ...MGColorSemanticBackgrounds,
};

export type TMGColorBackgrounds =
  | TMGColorLightBackgrounds
  | TMGColorPrimaryBackgrounds
  | TMGColorSemanticBackgrounds;

export type TMGColorTexts = keyof typeof MGColorsText;

export const MGTextColors = {
  "text-primary-01": MGColorsText["text-primary-01"].hex,
  "text-primary-02": MGColorsText["text-primary-02"].hex,
  "text-primary-03": MGColorsText["text-primary-03"].hex,
  "text-primary-04": MGColorsText["text-primary-04"].hex,
  "text-secondary-01": MGColorsText["text-secondary-01"].hex,
  "text-secondary-02": MGColorsText["text-secondary-02"].hex,
  "text-secondary-03": MGColorsText["text-secondary-03"].hex,
  "text-money-01": MGColorsText["text-money-01"].hex,
  "text-feedback-error-100": MGColorsText["text-feedback-error-100"].hex,
  "text-feedback-error-10": MGColorsText["text-feedback-error-10"].hex,
  "text-feedback-disabled": MGColorsText["text-feedback-disabled"].hex,
  "text-link-enabled-bg-light": MGColorsText["text-link-enabled-bg-light"].hex,
  "text-link-active-bg-light": MGColorsText["text-link-active-bg-light"].hex,
  "text-link-enabled-bg-dark": MGColorsText["text-link-enabled-bg-dark"].hex,
  "text-link-active-bg-dark": MGColorsText["text-link-active-bg-dark"].hex,
  "text-link-enabled-bg-brand": MGColorsText["text-link-enabled-bg-brand"].hex,
  "text-link-active-bg-brand": MGColorsText["text-link-active-bg-brand"].hex,
} as const;

export const MGBackgrounds = MGColorsBackgrounds;

export const MGComponentColors = {
  "field-disabled-dark": "#cccccc",
  "surface-selected": "#eeeeee",
  "surface-brand-hover": "#fff1ea",
  "button-brand-active": "#ffdd76",
  "button-success-hover": "#426020",
  "button-success-active": "#355018",
  "button-error-hover": "#a31538",
  "button-error-active": "#8b1230",
  "button-dark-hover": "rgba(245, 247, 250, 0.1)",
  "note-border": "#a6a8a9",
  "tag-warning-surface": "#fff0c2",
  "tag-warning-text": "#705100",
  "tag-success-surface": "#edf3df",
  "tag-purple-surface": "#eee5f5",
  "tag-purple-text": "#68427f",
  "tag-information-surface": "#e2f0f8",
  "shadow-popup": "#00000026",
  "shadow-card": "#0000001f",
} as const;
